import React from 'react'
import { FieldsGrid } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import { TicketField } from './TicketField'

export function TicketEvidenceFields() {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <TicketField />
      </FieldsGrid>
    </div>
  )
}
